import type {SourceDocument} from '@github-ui/taillights-worker/document'
import {createContext, type RefObject, use} from 'react'

import type {GoToLineSelection} from '../blob/BlobNavigationButtons'

export const SourceContext = createContext<SourceDocument | null>(null)
export const StartupErrorContext = createContext('')
export const SourceLabelContext = createContext('Source code')
export const TaillightsBlobContext = createContext(false)
export const TaillightsSelectionContext = createContext<RefObject<(() => GoToLineSelection | null) | null> | null>(null)

export function useCodeBlobSource() {
  const source = use(SourceContext)
  if (!source) throw new Error('CodeBlobTaillights requires a CodeBlobTaillightsProvider.')
  return source
}

export function useCodeBlobStartupError() {
  return use(StartupErrorContext)
}
